
// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import jsPDF from 'jspdf'
export default {
  install(Vue, options) {
    Vue.prototype.exportPdf = function (fileName) {
      //let a = document.createElement("a");
      const loading = this.$loading
        ? this.$loading({ lock: true, text: "正在生成PDF...", background: "rgba(0, 0, 0, 0.3)" })
        : null;
      const printEl = document.querySelector("#print");
      // 截图前隐藏按钮区及 no-print 元素，避免操作按钮被导出进PDF（与打印规则保持一致）
      const hideEls = printEl
        ? [...printEl.querySelectorAll(".slot_wrap, .no-print")]
        : [];
      hideEls.forEach(el => (el.style.display = "none"));
      const restore = () => hideEls.forEach(el => (el.style.display = ""));
      html2Canvas(printEl, {
        scale: 1,
        useCORS: true,
      }).then((canvas) => {
        restore();
        let dom = document.body.appendChild(canvas);
        dom.style.display = "none";
        // a.style.display = "none";
        var contentWidth = canvas.width - 20;
        var contentHeight = canvas.height;
        //一页pdf显示html页面生成的canvas高度;
        var pageHeight = (contentWidth / 572.28) * 821.89;
        //未生成pdf的html页面高度
        var leftHeight = contentHeight;
        //页面偏移
        var position = 20;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 557.28;
        var imgHeight = (572.28 / contentWidth) * contentHeight;

        var pageData = canvas.toDataURL("image/JPEG", 1.0);

        var pdf = new jsPDF("", "pt", "a4");

        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          pdf.addImage(pageData, "JPEG", 20, 20, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            pdf.addImage(pageData, "JPEG", 20, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            //避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage();
            }
          }
        }
        pdf.save(fileName + ".pdf");
        document.body.removeChild(dom);
        if (loading) loading.close();
      }).catch(() => {
        restore();
        if (loading) loading.close();
        if (this.$message) this.$message.error("导出PDF失败，请重试");
      });

    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/LYCom.js